module.exports = __webpack_public_path__ + "img/background-customer.1d9dc30f.svg";